module.exports = __webpack_public_path__ + "img/ico-pharmacy.bcbc34c0.svg";